import { PrinterOutlined, EyeOutlined } from "@ant-design/icons";
import {
  Button,
  Space,
  Table,
  Tooltip
} from "antd";

import React from 'react';
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL } from "../../utility/URL";

const SecurityDepositView = (props) => {
  console.log("Security Deposit Data", props.securityDepositList);

  const columns = [
    {
      title: 'S.No.',
      key: 'serial_no',
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Member Name',
      dataIndex: 'member',
      key: 'member',
      sorter: (a, b) => a.member.localeCompare(b.member),
      render: (text) => (
        <span style={{ fontWeight: 500 }}>{text}</span>
      ),
    },
    {
      title: 'Payment Date',
      dataIndex: 'payment_date',
      key: 'payment_date',
      sorter: (a, b) => {
        // Convert date strings to comparable format for sorting
        const dateA = new Date(a.payment_date.split('-').reverse().join('-'));
        const dateB = new Date(b.payment_date.split('-').reverse().join('-'));
        return dateA - dateB;
      },
    },
    {
      title: 'Payment No.',
      dataIndex: 'payment_no',
      key: 'payment_no',
      render: (text) => (
        <span style={{ fontFamily: 'monospace', fontSize: '12px' }}>{text}</span>
      ),
    },
    {
      title: 'Programme',
      dataIndex: 'programme_name',
      key: 'programme_name',
      render: (text) => (
        <span style={{ 
          backgroundColor: '#f0f0f0',
          padding: '2px 8px',
          borderRadius: '4px',
          fontSize: '12px'
        }}>
          {text}
        </span>
      ),
    },
    // {
    //   title: 'Description',
    //   dataIndex: 'description',
    //   key: 'description',
    //   ellipsis: {
    //     showTitle: false,
    //   },
    //   render: (text) => (
    //     <Tooltip placement="topLeft" title={text}>
    //       <span>{text}</span>
    //     </Tooltip>
    //   ),
    // },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      sorter: (a, b) => a.amount - b.amount,
      render: (amount) => (
        <div align="right" style={{ fontWeight: 600, color: '#1890ff' }}>
          ₹ {commonUtility.sanitizeValue(amount).toFixed(2)}
        </div>
      ),
    },
  ];

  // Calculate total amount
  const totalAmount = props.securityDepositList?.reduce((sum, item) => sum + item.amount, 0) || 0;

  return (
    <>
      <div style={{ marginBottom: 16, padding: 10, backgroundColor: '#f6f6f6', borderRadius: 4 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <span style={{ fontSize: '14px', color: '#666' }}>Total Records: </span>
            <span style={{ fontWeight: 600 }}>{props.securityDepositList?.length || 0}</span>
          </div>
          <div>
            <span style={{ fontSize: '14px', color: '#666' }}>Total Amount: </span>
            <span style={{ fontSize: '16px', fontWeight: 600, color: '#1890ff' }}>
              ₹ {commonUtility.sanitizeValue(totalAmount).toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      <Table 
        columns={columns} 
        rowKey='receipt_master_id' 
        dataSource={props.securityDepositList || []} 
        size="small"
      />
    </>
  );
};

export default SecurityDepositView;